var _circle, _rect, _rect2, _rect3, _rect4, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.9998,
    cy: 25.5994,
    r: 24.9998,
    fill: "#FAFAFA",
    stroke: "#DBDBDB",
    strokeWidth: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.17969,
    y: 1.24121,
    width: 35.6403,
    height: 10.9417,
    rx: 1.24875,
    fill: "#FDFDFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6758,
    y: 4.31348,
    width: 22.4711,
    height: 1.79711,
    rx: 0.898557,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6758,
    y: 7.61035,
    width: 30.5,
    height: 1.5,
    rx: 0.75,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.17969,
    y: 1.24121,
    width: 35.6403,
    height: 10.9417,
    rx: 1.24875,
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8505_62359",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 52,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 50.4996C40.083 50.4996 51.4996 39.083 51.4996 24.9998C51.4996 10.9167 40.083 -0.5 25.9998 -0.5C11.9167 -0.5 0.5 10.9167 0.5 24.9998C0.5 39.083 11.9167 50.4996 25.9998 50.4996Z",
    fill: "#FDFDFD",
    stroke: "#DBDBDB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8505_62359)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.17969,
    y: 15.8984,
    width: 35.6403,
    height: 37.4475,
    rx: 1.24875,
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6758,
    y: 18.3955,
    width: 22.4711,
    height: 1.79711,
    rx: 0.898557,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6758,
    y: 21.6924,
    width: 30.5,
    height: 1.5,
    rx: 0.75,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6758,
    y: 27.6934,
    width: 22.4711,
    height: 1.79711,
    rx: 0.898557,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6758,
    y: 30.9902,
    width: 30.5,
    height: 1.5,
    rx: 0.75,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6758,
    y: 36.9902,
    width: 22.4711,
    height: 1.79711,
    rx: 0.898557,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6758,
    y: 40.2871,
    width: 30.5,
    height: 1.5,
    rx: 0.75,
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.17969,
    y: 15.8984,
    width: 35.6403,
    height: 37.4475,
    rx: 1.24875,
    stroke: "#DBDBDB",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyX);
export default __webpack_public_path__ + "static/media/EmptyX.3397d440.svg";
export { ForwardRef as ReactComponent };